import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const RepsIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 18 18" {...props}>
      <path
        d="M9.00008 17.3332C4.39758 17.3332 0.666748 13.6023 0.666748 8.99984C0.666748 4.39734 4.39758 0.666504 9.00008 0.666504C13.6026 0.666504 17.3334 4.39734 17.3334 8.99984C17.3334 13.6023 13.6026 17.3332 9.00008 17.3332ZM13.0167 13.2298C14.0787 12.2193 14.7213 10.846 14.8167 9.3832C14.912 7.92037 14.4531 6.47528 13.5312 5.3355C12.6093 4.19572 11.2921 3.44481 9.84167 3.23221C8.39124 3.01961 6.91394 3.3609 5.70374 4.18818C4.49355 5.01545 3.63919 6.26804 3.3107 7.69669C2.9822 9.12534 3.20364 10.6253 3.93096 11.8981C4.65828 13.1708 5.83815 14.1231 7.23577 14.5654C8.63339 15.0077 10.1463 14.9075 11.4734 14.2848L10.6609 12.8223C9.83832 13.1799 8.92232 13.2624 8.04907 13.0577C7.17582 12.853 6.39193 12.3719 5.81394 11.6861C5.23594 11.0002 4.89469 10.1461 4.84091 9.25082C4.78713 8.35551 5.02369 7.46674 5.51543 6.71662C6.00716 5.96651 6.72783 5.39509 7.57029 5.08731C8.41276 4.77953 9.33206 4.75182 10.1915 5.0083C11.051 5.26477 11.8048 5.79174 12.3408 6.51087C12.8768 7.23 13.1665 8.10291 13.1667 8.99984H10.6667L13.0167 13.2298Z"
        fill={colors.grey}
      />
    </SvgIcon>
  );
};

export default RepsIcon;
